import React, { useState } from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import BungyManChatbot from './BungyManChatbot';

const FloatingButtons = () => {
  const [chatbotOpen, setChatbotOpen] = useState(false);

  return (
    <>
      <div className="fixed right-4 bottom-4 md:right-6 md:bottom-6 z-40 flex flex-col space-y-4">
        {/* BungyMan Chatbot Button - Top (Above Call) */}
        <button
          onClick={() => setChatbotOpen(true)}
          className="flex w-16 h-16 rounded-full bg-yellow-500 hover:bg-yellow-600 items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 group overflow-hidden border-4 border-yellow-400"
          aria-label="Chat with BungyMan"
        >
          <img 
            src="/Bungyman.png"
            alt="BungyMan"
            className="w-full h-full object-cover"
          />
          <span className="absolute right-20 bg-black text-white px-3 py-1 rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap hidden md:block">
            Chat with BungyMan
          </span>
        </button>

        {/* Call Button - Middle (Above WhatsApp, Below BungyMan) */}
        <a
          href="tel:+918506865393"
          className="flex w-14 h-14 rounded-full bg-blue-500 hover:bg-blue-600 items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 group"
          aria-label="Call us"
        >
          <Phone className="text-white" size={28} />
          <span className="absolute right-16 bg-black text-white px-3 py-1 rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap hidden md:block">
            Call Now
          </span>
        </a>
      </div>

      {/* BungyMan Chatbot */}
      <BungyManChatbot isOpen={chatbotOpen} onClose={() => setChatbotOpen(false)} />
    </>
  );
};

export default FloatingButtons;
